<template>
    <div>
        <!-- Custom Type -->
        <div class='row' v-if='object.custom_type'>
            <div class='col-md-3'><strong>{{object.custom_type.label}}</strong></div>
            <div class='col-md-9'>
                {{concatProps(object, 'custom_type', ', ')}}
            </div>
        </div>

        <!-- Artist/Maker -->
        <noncustom-prop v-if="object.artist"
            :object='object'
            :property='{label: object.artist.label, column: "artist"}'
            link='searchable-actors-keyword'>
        </noncustom-prop>

        <!-- Object Date -->
        <noncustom-prop v-if="object.categ_16"
            :object='object'
            :property='{label: object.categ_16.label, column: "categ_16"}'>
        </noncustom-prop>

        <!-- Material -->
        <div class='row' v-if='object.custom_material'>
            <div class='col-md-3'><strong>{{object.custom_material.label}}</strong></div>
            <div class='col-md-9'>
                {{concatProps(object, 'custom_material', ', ')}}
            </div>
        </div>

        <!-- Custom Catalog -->
        <noncustom-prop v-if="object.custom_catalog"
            :object='object'
            :property='{label: object.custom_catalog.label, column: "custom_catalog"}'>
        </noncustom-prop>

        <!-- Catalog Number -->
        <noncustom-prop v-if="object.cat_nbr"
            :object='object'
            :property='{label: object.cat_nbr.label, column: "cat_nbr"}'>
        </noncustom-prop>
    </div>
</template>

<script>
    import ManageProperties from './../../mixins/manageProperties.js'
    import ViewRelated from '../../mixins/viewRelated.js'
    import NoncustomVue from './parts/noncustom.vue'

    export default {
        name: 'object-summary',
        props: ['object'],
        mixins: [ManageProperties, ViewRelated],
        components: {
            'noncustom-prop': NoncustomVue,
        },
    };
</script>
